import initialState from './initialState';
import Immutable from 'immutable';
import createReducer from './createReducer';
import { LOADING_USER } from 'redux-oidc';


const rehydrate = (state, action) => {
    if (action.payload.message) {
        state = action.payload.message;
    }
    return state.set('stateReady', true);
};

const loadingUser = (state, action) => {
    return state
        .set('userChannelGrantFinished', false)
        ;
};

const setUserChannelGrantStarted = (state) => {
    return state
        .set('userChannelGrantStarted', true)
        .set('userChannelGrantFinished', false)
        ;
};
const setuserChannelGrantFinished = (state, action) => {
    return state
        .set('userChannelGrantStarted', false)
        .set('userChannelGrantFinished', true)
        ;
};
const setUserChannelGrantAppianStarted = (state) => {
    return state
        .set('userChannelGrantAppianStarted', true)
        .set('userChannelGrantAppianFinished', false)
        .set('appianGrantChannelAuthKey', null);
};
const setUserChannelGrantAppianFinished = (state, action) => {
    return state
        .set('userChannelGrantAppianStarted', false)
        .set('userChannelGrantAppianFinished', true)
        .set('appianGrantChannelAuthKey', action.authKey);
};

const handlers = {
    'persist/REHYDRATE': rehydrate,
    'USER_CHANNEL_GRANT_STARTED': setUserChannelGrantStarted,
    'USER_CHANNEL_GRANT_FINISHED': setuserChannelGrantFinished,
    'USER_CHANNEL_GRANT_APPIAN_STARTED': setUserChannelGrantAppianStarted,
    'USER_CHANNEL_GRANT_APPIAN_FINISHED': setUserChannelGrantAppianFinished,
};

handlers[LOADING_USER] = loadingUser;

export default createReducer(initialState.get('message'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/messageReducer.js